import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=535ea0c2&scoped=true&"
import script from "./LeftMenu.vue?vue&type=script&lang=ts&"
export * from "./LeftMenu.vue?vue&type=script&lang=ts&"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=535ea0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535ea0c2",
  null
  
)

export default component.exports